import APIClient from './index';
import _ from 'lodash';

export const authenticateUserSession = userCredentialsData => {
  return new Promise((resolve, reject) => {
    APIClient.post('Auth/session', userCredentialsData)
      .then(response => resolve(response?.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};

export const logoutUserSession = () => {
  return new Promise((resolve, reject) => {
    APIClient.post('Auth/logout')
      .then(response => resolve(response?.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};

export const resetUserPassword = newCredentialsData => {
  return new Promise((resolve, reject) => {
    APIClient.post('Auth/reset_password', newCredentialsData)
      .then(response => resolve(response?.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};

export const forgotPasswordRequest = email => {
  return new Promise((resolve, reject) => {
    APIClient.post('Auth/forgot_password_request', { email })
      .then(response => resolve(response?.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};

export const forgotPasswordConfirm = newCredentialsData => {
  return new Promise((resolve, reject) => {
    APIClient.post('Auth/forgot_password_confirm', newCredentialsData)
      .then(response => resolve(response?.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};
